


import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class AuthAdmin_Or_AdminMember_Guard  {


	constructor(
		private router: Router,
		private authService: AuthenticationService
	) {}


	canActivate() {

		if( !this.authService.isAdmin() && !this.authService.isAdminMember() ) {

			this.router.navigate( ['auth/login'] );
			return false;

		}

		return true;
	}

}
